module.exports = __webpack_public_path__ + "static/media/tourism-boards-2.59b900c2.jpg";